import React, { useEffect, useState } from "react";
import { useUserStore } from "../../contexts/userStore";
import TreeView from "../TreeView/TreeView"
import { useAuth } from "../../contexts/auth";
import { DynamicIcon } from "../DynamicIcon/DynamicIcon";
import { Tooltip, TooltipContent, TooltipTrigger } from "../shadcn/tooltip";

export const UnitsTreeView = ({ unitsArg = null, singleCheck, showRoot, scopedUnitId, onChange, values = [], checkableUnits = null, ...props }) => {
	const [treeData, setTreeData] = useState([]);
	const { condominiums } = useUserStore();
	const { user } = useAuth();
	const unitsList = unitsArg ?? condominiums;

	useEffect(() => {
		setTreeData(prevTreeData => {
			let units = (user.userData.isSuperAdmin || user.userData.person.hasRootAccess) ? [...unitsList] : [...unitsList.filter(unit => user.userData.selectedOrganizationId === unit.organizationId)];
			if (scopedUnitId) {
				units = units.filter(unit => unit.id === `${scopedUnitId}` || unit.ancestorIds?.includes(`${scopedUnitId}`));
			}
			const children = buildTreeUnits(units.sort((unitA, unitB) => unitA.name.localeCompare(unitB.name)));
			if (showRoot && (user.userData.isSuperAdmin || user.userData.hasRootAccess)) {
				return [
					{
						id: 'root',
						name: 'Bravas Root',
						checked: values?.includes('root'),
						children,
					}
				];
			}
			return children;
		})
	}, [unitsList]);

	function buildTreeUnits(units) {
		function traverseUnits(unit) {
			if (!unit) return;
			units.forEach((u, idx) => {
				unit.important = unit.isSubOrganization || !unit.parentId;
				unit.extraContent = () => {
					return (
						<div className="inline-flex gap-1.5 items-center px-2! py-0! rounded-full">
							{/* <span>(Level: {unit.level})</span> */}
							{unit.tags.map(tag => (
								<Tooltip>
									<TooltipTrigger asChild>
										<DynamicIcon iconName={tag.icon} color={tag.color} size={18} />
									</TooltipTrigger>
									<TooltipContent>
										<p>{tag.name}</p>
									</TooltipContent>
								</Tooltip>
							))}
						</div>
					);
				}
				if (unit.id !== u.parentId) {
					return;
				}
				unit.children = unit.children || [];
				unit.children.push(traverseUnits({ ...u }));
			});
			return unit;
		}
		const roots = units.filter(unit => unit.parentId === null);
		const orphans = units.filter(unit => unit.parentId !== null && !units.find(u => u.id === unit.parentId));
		roots.push(...orphans);
		const tree = [];
		if (roots.length > 0) {
			roots?.forEach((root) => {
				tree.push(traverseUnits({ ...root, name: `${root.name}` }));
			});
		}

		return tree;
	}

	return (
		<TreeView
			data={treeData}
			onChange={onChange}
			showRoot={showRoot}
			selectedIds={values}
			checkableIds={checkableUnits?.map(unit => unit.id)}
			singleCheck={singleCheck}
		/>
	)
}